import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router-dom';
import DataTable from 'react-data-table-component';
import { push } from 'connected-react-router';
import Button from '@material-ui/core/Button';
import Modal from '@material-ui/core/Modal';
import { makeStyles } from '@material-ui/core/styles';
import * as actions from '../actions/project';
import TextField from '@material-ui/core/TextField';

const customStyles = {
   headRow: {
      style: {
         border: 'none',
      },
   },
   headCells: {
      style: {
         color: '#202124',
         fontSize: '14px',
      },
   },
   rows: {
      highlightOnHoverStyle: {
         backgroundColor: 'rgb(230, 244, 244)',
         borderBottomColor: '#FFFFFF',
         outline: '1px solid #FFFFFF',
      },
   },
   pagination: {
      style: {
         border: 'none',
      },
   },
   table: {
      style: {
         width: '800px',
      },
   },
};

const useStyles = makeStyles((theme) => ({
   modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
   },
   paper: {
      backgroundColor: theme.palette.background.paper,
      border: '2px solid #000',
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 4, 3),
   },
}));

function ToBeStrategyMapList({
   createToBeStrategyMap,
   data,
   getAllToBeStrategyMap,
   match: {
      params: { projectId },
   },
}) {
   React.useEffect(() => {
      getAllToBeStrategyMap(projectId);
   }, [projectId]);

   const columns = [
      {
         name: 'Title',
         cell: (row) => (
            <Link size="small" to={`/project/${projectId}/tobestrategymap/${row.id}`}>
               {row.title}
            </Link>
         ),
         allowOverflow: true,
         button: false,
         sortable: true,
         grow: 2,
         style: {
            color: '#202124',
            fontSize: '14px',
            fontWeight: 500,
         },
      },
      {
         name: 'Updated at',
         selector: 'updated_at',
         cell: (row) => row.updated_at.substring(0, 10),
         sortable: true,
         style: {
            color: 'rgba(0,0,0,.54)',
         },
      },
   ];
   const updateState = (o) => push(`/project/${projectId}/tobestrategymap/${o.id}`);
   const [open, setOpen] = React.useState(false);
   const classes = useStyles();

   const [values, setValues] = React.useState({
      title: '',
   });

   const handleChange = (name) => (event) => {
      setValues({ ...values, [name]: event.target.value });
   };

   const handleClick = (event) => {
      createToBeStrategyMap(values.title, projectId);
      setOpen(false);
   };

   return (
      <>
         <DataTable
            title={`To-Be Strategy Canvas`}
            columns={columns}
            data={data}
            onRowClicked={updateState}
            customStyles={customStyles}
            highlightOnHover
            pointerOnHover
            actions={
               <Button
                  variant="contained"
                  color="primary"
                  onClick={() => setOpen(true)}
                  style={{
                     background: 'linear-gradient(45deg, #1c7ff4 30%, #45adf7',
                  }}
               >
                  create
               </Button>
            }
         />
         <Modal
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
            className={classes.modal}
            open={open}
            onClose={() => setOpen(false)}
         >
            <div className={classes.paper}>
               <form className={classes.root} noValidate autoComplete="off">
                  <TextField id="title" label="name" value={values.title} onChange={handleChange('title')} />
                  <Button
                     variant="contained"
                     color="primary"
                     style={{
                        background: 'linear-gradient(45deg, #1c7ff4 30%, #45adf7',
                     }}
                     onClick={() => handleClick()}
                  >
                     Create
                  </Button>
               </form>
            </div>
         </Modal>
      </>
   );
}

const mapStateToProps = (state) => state.toBeStrategyMap;
const mapDispatchToProps = (dispatch) => bindActionCreators(actions, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ToBeStrategyMapList);
